<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_3514_34269)">
			<path
				d="M8.00004 1.3335C4.32004 1.3335 1.33337 4.32016 1.33337 8.00016C1.33337 11.6802 4.32004 14.6668 8.00004 14.6668C11.68 14.6668 14.6667 11.6802 14.6667 8.00016C14.6667 4.32016 11.68 1.3335 8.00004 1.3335ZM6.66671 11.3335L3.33337 8.00016L4.27337 7.06016L6.66671 9.44683L11.7267 4.38683L12.6667 5.3335L6.66671 11.3335Z"
				fill="#2A8176"
			/>
		</g>
        
		<defs>
			<clipPath id="clip0_3514_34269">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

